import React from 'react';
import {
  MenuItem,
  FormControl,
  Select,
  Box,
  Typography,
} from '@mui/material';

const CommonDropdown = ({
  value,
  onChange,
  options = [],
  label = 'Select Board',
  roundBorder = true,
  disabledOptions = [],
  width,
  ...props
}) => {
  return (
    <Box >
      {/* 🔹 Top Label */}
      <Box
        sx={{
          backgroundColor: '#E6E6E6',
          borderTopLeftRadius: roundBorder ? '14px' : '6px',
          borderTopRightRadius: roundBorder ? '14px' : '6px',
          width: width || '200px',
          mb: '-10px',
          position: 'relative',
          zIndex: 2,
          padding: "10px 20px",
          height: "40px",

        }}
      >
        <Typography fontSize={14} color="#8C8C8C">
          {label}
        </Typography>
      </Box>

      {/* 🔹 Dropdown */}
      <FormControl sx={{ width: width || '200px' }}>
        <Select
          value={value}
          onChange={onChange}
          sx={{
            width: width || '200px',
            backgroundColor: '#FFFFFF',
            borderRadius: roundBorder ? '20px' : '8px',
            height: '60px',
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiSelect-select': {
              padding: '16px 18px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#231F20',
            },
          }}
          {...props}
        >
          {options.map((option) => (
            <MenuItem
              sx={{
                width: width || '200px',
              }} key={option.value}
              value={option.value}
              disabled={disabledOptions.includes(option.value)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CommonDropdown;
